// @yeger/vue-masonry-wall v6 ja no exporta un plugin de Vue (app.use), només
// el component. El registrem global per mantenir <masonry-wall> als templates.
import { MasonryWall } from "@yeger/vue-masonry-wall";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("masonry-wall", MasonryWall);
});
